// ============================================================
// VCS.DatingRadar — Radar fuer den Nah-Modus
// ============================================================
// Pendant zu dating_radar.dart. Flutter zeichnet mit CustomPainter, im Browser
// ist das ein <canvas> mit requestAnimationFrame -- die Logik ist dieselbe.
//
// DIE BLIPS SIND GEMESSEN, NICHT GEWUERFELT (seit 16.07.). Richtung und
// Entfernung kommen aus der Differenz der Geo-Zellen: Norden ist oben, aussen
// ist weiter weg. Vorher sassen sie auf einem Hash des Handles -- huebsch, aber
// gelogen: Zwei Leute im selben Zimmer lagen an gegenueberliegenden Raendern.
// Der Gruender hat das bewusst geaendert ("wer die App benutzt, dem sollte klar
// sein, dass man ihn in dem Modus finden kann"), und ohne echte Punkte haette
// das geplante Finde-mich-Spiel keine Grundlage. Die Einwilligung ersetzt das
// fruehere Verbot -- deshalb steht im Profil ein Schalter mit ehrlichem Text.
//
// GENAUER ALS DIE ZELLE GEHT ES NICHT. Wie fein die ist, entscheidet ihr
// Besitzer selbst: ~750 m (ungefaehr) oder ~38 m (genau). Innerhalb seiner
// eigenen Zelle streut das Radar den Punkt deshalb weiter per Hash -- nicht als
// Deko, sondern weil dort niemand mehr weiss. Ein Punkt exakt im Zellzentrum
// wuerde eine Praezision behaupten, die es nicht gibt.
//
// Was hier trotzdem FEHLT, obwohl jedes Flugradar es haette: kein Kompass,
// keine Nordmarke, keine Gradzahlen, keine beschrifteten Entfernungsringe. Die
// Richtung darf man sehen, ablesen soll man sie nicht -- sonst wird aus "da
// drueben ist jemand" eine Peilung.
//
// Der Radar dreht IMMER -- auch wenn niemand da ist. Ein suchendes Radar sagt
// "ich bin fuer dich dran", ein leerer Bildschirm sagt "hier ist nichts los,
// geh wieder".
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingRadar = class {

    // ── Konstanten ───────────────────────────────────────────

    // Eine Umdrehung. Langsam genug, dass das Aufleuchten der Blips ein Ereignis
    // bleibt — bei einer schnellen Runde wirkt es wie Flackern.
    static SWEEP_MS = 4000;

    // Wie nah ein Tipp an einem Blip liegen muss. Grosszuegiger als der Punkt
    // aussieht — getroffen werden soll der Mensch, nicht das Pixel.
    static TAP_RADIUS = 30;

    // Wie lange ein Blip nachleuchtet, nachdem der Strahl ueber ihn lief.
    // Gut eine Drittelrunde — danach bleibt er als schwacher Punkt stehen.
    static AFTERGLOW = 2.4;

    static RINGS = [0.32, 0.58, 0.82, 1.0];

    // Wie weit der aeussere Rand reicht. Die Suche geht ueber die 3x3-Nachbarschaft
    // der eigenen P6-Zelle, also gut einen Kilometer in jede Richtung — mit
    // Streuung innerhalb der Zelle kommt man auf knapp 1,2 km. Wer weiter weg
    // ist, klebt am Rand statt zu verschwinden.
    static RANGE_METERS = 1200;

    // Meter pro Grad Breite. Fuer gut einen Kilometer reicht die flache
    // Naeherung; die Erdkruemmung spielt erst bei Hunderten von Kilometern eine
    // Rolle.
    static METERS_PER_DEGREE = 111320;

    // Ton beim Ueberstreichen. Kurz und leise: Das Radar laeuft dauerhaft, ein
    // langer oder lauter Ping waere nach zwei Runden eine Zumutung.
    static BEEP_MS      = 70;
    static BEEP_VOLUME  = 0.06;
    // Naeher = hoeher. Eine Oktave zwischen Rand und Mitte — mehr braucht es
    // nicht, damit man Naehe hoert, ohne dass es nach Melodie klingt.
    static BEEP_HZ_FAR  = 660;
    static BEEP_HZ_NEAR = 1320;
    // Zwei Menschen an fast derselben Stelle sollen zweimal piepen, zwanzig
    // nicht gleichzeitig. Deckel gegen Krach.
    static BEEP_MIN_GAP_MS = 60;

    static SOUND_STORAGE_KEY = 'datingRadarSound';

    // Kommt eine Gruppe gleichzeitig an, schickt jeder radar-peer eine
    // Deck-Anfrage los. Entprellt: einmal fuer alle.
    static PEER_RELOAD_DEBOUNCE_MS = 2000;

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {
            body: $('#datingRadarBody')
        };

        this._deck    = [];
        this._error   = '';
        this._running = false;
        this._raf     = 0;
        this._canvas  = null;
        this._ctx     = null;
        this._side    = 0;
        this._colors  = null;

        // Die eigene Zelle — Bezugspunkt fuer Richtung und Entfernung. Ohne sie
        // gibt es kein "da drueben".
        this._myCell  = '';
        this._profile = null;

        // Praesenz laeuft ueber den Socket: kein Polling, kein Puls.
        this._entered      = false;   // radar-enter gesendet und noch nicht verlassen
        this._watchId      = 0;
        this._reloadTimer  = 0;
        this._onVisibility = () => this._handleVisibility();

        // Ton: Zustand pro Blip, um den Moment des Ueberstreichens zu erkennen.
        this._audioCtx  = null;
        this._lastDelta = new Map();   // handle -> delta des letzten Frames
        this._lastBeep  = 0;
        this._sound     = this._loadSoundPref();

        this._onResize = () => this._resize();
    }

    // ── Ton ──────────────────────────────────────────────────

    _loadSoundPref() {
        try {
            // Voreingestellt an: Ein Radar, das nicht piept, ist ein Diagramm.
            // Wer es nicht will, schaltet es aus — und das bleibt dann so.
            return localStorage.getItem(VCS.DatingRadar.SOUND_STORAGE_KEY) !== '0';
        } catch (_) {
            return true;
        }
    }

    _saveSoundPref() {
        try {
            localStorage.setItem(VCS.DatingRadar.SOUND_STORAGE_KEY, this._sound ? '1' : '0');
        } catch (_) {}
    }

    toggleSound() {
        this._sound = !this._sound;
        this._saveSoundPref();
        if (this._sound) {
            // Der Klick IST die Nutzergeste — hier darf der Context aufwachen.
            this._ensureAudio();
        }
        $('.dating-radar-status').html(this._statusHtml());
        console.log('[dating] Radar-Ton ' + (this._sound ? 'an' : 'aus'));
    }

    // Browser lassen Ton ohne Nutzergeste nicht zu. Der Context wird deshalb
    // erst beim ersten Bedarf gebaut und bei Bedarf geweckt — iOS-Safari
    // suspendiert ihn ausserdem beim Wegschalten. webkit-Praefix wie in
    // audio-monitor.js: Aeltere iOS-Versionen kennen AudioContext nicht.
    _ensureAudio() {
        if (this._audioCtx) {
            if (this._audioCtx.state === 'suspended') {
                this._audioCtx.resume().catch(() => {});
            }
            return this._audioCtx;
        }
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) {
            return null;
        }
        try {
            this._audioCtx = new AudioCtx();
        } catch (_) {
            return null;
        }
        if (this._audioCtx.state === 'suspended') {
            this._audioCtx.resume().catch(() => {});
        }
        return this._audioCtx;
    }

    // Ein kurzer Ping. Oszillator statt Audiodatei: kein Download, kein
    // Cache-Thema, und die Tonhoehe darf von der Entfernung abhaengen.
    _beep(distance) {
        if (!this._sound) {
            return;
        }
        const now = Date.now();
        if (now - this._lastBeep < VCS.DatingRadar.BEEP_MIN_GAP_MS) {
            return;
        }
        const ctx = this._ensureAudio();
        if (!ctx || ctx.state !== 'running') {
            return;   // Noch keine Geste gehabt: lieber still als kaputt.
        }
        this._lastBeep = now;

        const R  = VCS.DatingRadar;
        const t0 = ctx.currentTime;
        const dur = R.BEEP_MS / 1000;
        // distance 0..0.95 -> nah = hoch
        const hz = R.BEEP_HZ_NEAR + (R.BEEP_HZ_FAR - R.BEEP_HZ_NEAR) * Math.min(distance, 1);

        try {
            const osc  = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(hz, t0);
            // Huellkurve: sofort da, dann exponentiell aus. Ein harter Schnitt
            // klickt, ein linearer Ausklang klingt nach Ton statt nach Ping.
            gain.gain.setValueAtTime(0.0001, t0);
            gain.gain.exponentialRampToValueAtTime(R.BEEP_VOLUME, t0 + 0.008);
            gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start(t0);
            osc.stop(t0 + dur + 0.02);
            // Aufraeumen: Ohne disconnect haengen die Knoten bis zum GC am Graph.
            osc.onended = () => { try { osc.disconnect(); gain.disconnect(); } catch (_) {} };
        } catch (_) {}
    }

    init() {
        this._bindEvents();
    }

    // ── Lifecycle ────────────────────────────────────────────

    async onShow() {
        document.addEventListener('visibilitychange', this._onVisibility);
        await this._load();
    }

    onHide() {
        this._stop();
        this._leaveRadar();
        document.removeEventListener('visibilitychange', this._onVisibility);
        // Sonst piept der erste Frame beim naechsten Betreten fuer jeden Blip,
        // dessen delta zufaellig kleiner ist als beim Verlassen.
        this._lastDelta.clear();
        window.removeEventListener('resize', this._onResize);
    }

    onLangChange() {
        if (VCS.dating?.currentView?.() === 'radar' && VCS.dating?.isOpen?.()) {
            this._render();
        }
    }

    // ── Laden ────────────────────────────────────────────────

    // Der Radar ist nur eine zweite Darstellung von /dating/deck?mode=local —
    // kein eigener Endpoint. Das Radar ist immer Nah: Es gibt nichts abzutasten,
    // wenn jemand am anderen Ende der Welt sitzt.
    async _load() {
        this._stop();
        this._leaveRadar();
        this._renderLoading();
        this._error = '';

        const profile = await VCS.datingCore.getProfile();
        if (!profile) {
            this._error = 'no_profile';
            this._render();
            return;
        }
        this._profile = profile;
        // Nur-Fern-Profile koennen kein Radar haben. Kein Serverfehler, sondern
        // eine Einstellung.
        if (profile.mode === 'remote') {
            this._error = 'mode_mismatch';
            this._render();
            return;
        }

        // syncCell (nicht nur currentCell): das Radar braucht die eigene Zelle IMMER am
        // Server -- deck?fresh=1 antwortet sonst no_cell. Das Deck setzt sie nur bei
        // Radius < "egal"; wer "egal" waehlt oder direkt ins Radar geht, haette sonst
        // serverseitig keine Zelle. syncCell ermittelt UND setzt sie ('' wenn Ortung verweigert).
        const cell = await VCS.datingGeo.syncCell(profile.cellPrecision);
        if (!cell) {
            this._error = 'no_location';
            this._render();
            return;
        }
        this._myCell = cell;

        // Das Deck einmal per REST: Namen, Bio und Fotos kommen bewusst NICHT
        // ueber den Socket — der traegt nur Praesenz und Position.
        // fresh=1 filtert serverseitig auf die Socket-Praesenz: Wer nicht am
        // Socket haengt, ist im Radar nicht da.
        const result = await VCS.datingCore.getDeck(false, true);
        this._deck  = result.deck || [];
        this._error = result.ok ? '' : (result.error || 'unknown');
        console.log('[dating] Radar geladen: blips=' + this._deck.length
            + ' eigene Zelle=' + this._myCell
            + (this._error ? ' error=' + this._error : ''));

        this._render();
        if (!this._error) {
            this._enterRadar();
        }
    }

    // ── Praesenz ueber den Socket ────────────────────────────
    // DIE VERBINDUNG IST DIE ANWESENHEIT. Wer am Socket haengt, ist im Radar;
    // faellt die Verbindung, ist der Blip bei allen anderen sofort weg. Das
    // ersetzt das frueher noetige Pulsen alle 30 s samt Zeitfenster: Wer
    // stillsteht, sendet nichts mehr, und eine Bewegung ist sofort drueben statt
    // nach bis zu einer Minute.

    _enterRadar() {
        if (!this._myCell) {
            return;
        }
        VCS.signaling?.send?.({ type: 'radar-enter', cell: this._myCell });
        this._entered = true;
        console.log('[dating] radar-enter: ' + this._myCell);

        // Bewegung verfolgen. Gesendet wird nur bei Zellwechsel — der
        // Zellen-Vergleich ersetzt den distanceFilter, den der Browser nicht hat.
        // Die eben gemeldete Zelle geht mit rein, sonst meldet der erste
        // Callback einen Wechsel auf genau sie.
        this._watchId = VCS.datingGeo.startWatch(this._profile?.cellPrecision, (cell) => {
            this._myCell = cell;
            VCS.signaling?.send?.({ type: 'radar-move', cell: cell });
            console.log('[dating] radar-move: ' + cell);
        }, this._myCell);
    }

    _leaveRadar() {
        if (this._watchId) {
            VCS.datingGeo.stopWatch(this._watchId);
            this._watchId = 0;
        }
        if (this._reloadTimer) {
            clearTimeout(this._reloadTimer);
            this._reloadTimer = 0;
        }
        if (this._entered) {
            VCS.signaling?.send?.({ type: 'radar-leave' });
            this._entered = false;
            console.log('[dating] radar-leave');
        }
    }

    // ── Eingehende Praesenz ──────────────────────────────────

    // Jemand ist da oder hat sich bewegt. Kennen wir ihn aus dem Deck, reicht
    // die neue Zelle — Name, Bio und Foto haben wir schon. Ist er neu, fehlen
    // uns die Stammdaten und wir holen das Deck nach.
    onPeer(msg) {
        if (!msg || !msg.handle || !this._entered) {
            return;
        }
        const known = this._deck.find((c) => c.handle === msg.handle);
        if (known) {
            known.cell = msg.cell || '';
            // Kein Neuaufbau: Der naechste Frame zeichnet ihn ohnehin an der
            // neuen Stelle, und ein Rerender liesse das Canvas wegblitzen.
            return;
        }
        this._scheduleReload();
    }

    onGone(msg) {
        if (!msg || !msg.handle) {
            return;
        }
        // Nicht entfernen, wenn der Nutzer gerade dessen Karte offen hat — wer
        // liest, soll zu Ende lesen duerfen. Der Stapel hat seine eigene Kopie;
        // hier verschwindet der Blip erst, wenn das Radar wieder dran ist.
        const inDeck = VCS.dating?.currentView?.() === 'deck'
            && VCS.datingDeck?.currentHandle?.() === msg.handle;
        if (inDeck) {
            console.log('[dating] radar-gone ignoriert (Karte offen): ' + msg.handle);
            return;
        }
        const before = this._deck.length;
        this._deck = this._deck.filter((c) => c.handle !== msg.handle);
        this._lastDelta.delete(msg.handle);
        if (this._deck.length !== before) {
            console.log('[dating] radar-gone: ' + msg.handle + ' -> blips=' + this._deck.length);
            $('.dating-radar-status').html(this._statusHtml());
        }
    }

    // Nach einem Reconnect ist der Socket ein anderer — der Server kennt uns
    // dort nicht mehr. Also neu anmelden, sobald er wieder authentifiziert ist.
    onSocketAuthed() {
        if (!this._entered || VCS.dating?.currentView?.() !== 'radar') {
            return;
        }
        console.log('[dating] Socket neu authentifiziert -> radar-enter erneut');
        VCS.signaling?.send?.({ type: 'radar-enter', cell: this._myCell });
        // Das Deck kann sich waehrend der Trennung geaendert haben.
        this._scheduleReload();
    }

    // Unbekannter Handle: Stammdaten nachladen. Entprellt, weil bei einer
    // ankommenden Gruppe sonst fuer jeden Einzelnen eine Anfrage losginge.
    _scheduleReload() {
        if (this._reloadTimer) {
            return;
        }
        this._reloadTimer = setTimeout(async () => {
            this._reloadTimer = 0;
            if (!this._entered || VCS.dating?.currentView?.() !== 'radar') {
                return;
            }
            const result = await VCS.datingCore.getDeck(false, true);
            if (!result.ok || VCS.dating?.currentView?.() !== 'radar') {
                return;
            }
            this._deck = result.deck || [];
            console.log('[dating] Deck nachgeladen: blips=' + this._deck.length);
            $('.dating-radar-status').html(this._statusHtml());
        }, VCS.DatingRadar.PEER_RELOAD_DEBOUNCE_MS);
    }

    // iOS-Safari friert Hintergrund-Tabs ein, der Socket faellt, und man
    // verschwindet aus fremden Radaren. Das ist kein Bug, sondern die Wahrheit:
    // Man ist gerade nicht da. Beim Zurueckkommen muss aber sauber neu angemeldet
    // werden -- und im Hintergrund hat die Ortung nichts zu suchen.
    _handleVisibility() {
        if (VCS.dating?.currentView?.() !== 'radar') {
            return;
        }
        if (document.hidden) {
            if (this._watchId) {
                VCS.datingGeo.stopWatch(this._watchId);
                this._watchId = 0;
            }
            return;
        }
        // Zurueck im Vordergrund: Ortung wieder an. Haelt der Socket noch, ist
        // radar-enter nur eine Auffrischung; ist er weg, uebernimmt
        // onSocketAuthed nach dem Reconnect.
        if (this._entered && !this._watchId) {
            this._watchId = VCS.datingGeo.startWatch(this._profile?.cellPrecision, (cell) => {
                this._myCell = cell;
                VCS.signaling?.send?.({ type: 'radar-move', cell: cell });
            }, this._myCell);
            VCS.signaling?.send?.({ type: 'radar-enter', cell: this._myCell });
            this._scheduleReload();
        }
    }

    // ── Rendern ──────────────────────────────────────────────

    _renderLoading() {
        this._view.body.html('<div class="dating-loading"><div class="dating-spinner"></div></div>');
    }

    _render() {
        if (this._error) {
            this._stop();
            this._renderError();
            return;
        }

        this._view.body.html(
            '<div class="dating-radar-wrap"><canvas id="datingRadarCanvas"></canvas></div>'
            + '<div class="dating-radar-status">' + this._statusHtml() + '</div>'
        );

        this._canvas = document.getElementById('datingRadarCanvas');
        this._ctx    = this._canvas ? this._canvas.getContext('2d') : null;
        if (!this._ctx) {
            return;
        }
        this._resize();
        window.removeEventListener('resize', this._onResize);
        window.addEventListener('resize', this._onResize);
        this._start();
    }

    // „Es sucht" — kein „nichts gefunden". Ein suchendes Radar sagt „ich bin
    // fuer dich dran"; „niemand da" sagt „geh wieder". Gleicher Sachverhalt,
    // anderes Gefuehl.
    // Lautsprecher an/aus. Sitzt beim Status statt in der Kopfzeile: Der Ton
    // gehoert zum Radar, nicht zum Dating-Teil — wer die Ansicht verlaesst, hat
    // ihn ohnehin nicht mehr.
    _soundBtnHtml() {
        const on = this._sound;
        const icon = on
            ? '<path d="M11 5L6 9H2v6h4l5 4z"></path><path d="M15.5 8.5a5 5 0 0 1 0 7"></path><path d="M19 5a9 9 0 0 1 0 14"></path>'
            : '<path d="M11 5L6 9H2v6h4l5 4z"></path><line x1="22" y1="9" x2="16" y2="15"></line><line x1="16" y1="9" x2="22" y2="15"></line>';
        return '<button type="button" class="dating-radar-sound' + (on ? ' is-on' : '') + '"'
            + ' data-dating-radar-sound aria-pressed="' + (on ? 'true' : 'false') + '"'
            + ' aria-label="' + escapeHtml(t('datingRadarSound')) + '"'
            + ' title="' + escapeHtml(t('datingRadarSound')) + '">'
            + '<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="1.8"'
            + ' fill="none" stroke-linecap="round" stroke-linejoin="round">' + icon + '</svg></button>';
    }

    _statusHtml() {
        if (!this._deck.length) {
            return '<div class="dating-radar-searching">' + escapeHtml(t('datingRadarSearching')) + '</div>'
                + '<div class="dating-radar-hint">' + escapeHtml(t('datingRadarSearchingHint')) + '</div>'
                + '<div class="dating-radar-actions">' + this._soundBtnHtml() + '</div>';
        }
        // Die Zahl gross und fuer sich: Ziffern brauchen keine Uebersetzung und
        // ersparen die Plural-Frage („1 Mensch" / „3 Menschen").
        return '<div class="dating-radar-count">' + this._deck.length + '</div>'
            + '<div class="dating-radar-nearby">' + escapeHtml(t('datingRadarNearby')) + '</div>'
            + '<div class="dating-radar-hint">' + escapeHtml(t('datingRadarTapHint')) + '</div>'
            + '<div class="dating-radar-actions">'
            + '<button type="button" class="dating-state-link" data-dating-radar-browse>'
            + escapeHtml(t('datingRadarBrowse')) + '</button>'
            + this._soundBtnHtml()
            + '</div>';
    }

    _renderError() {
        // Dieselben Faelle wie im Stapel — der Radar hat keine eigenen.
        const info = VCS.DatingDeck.errorInfo(this._error);
        this._view.body.html(
            '<div class="dating-state">'
            + '<h3 class="dating-state-title">' + escapeHtml(info.title) + '</h3>'
            + '<p class="dating-state-body">' + escapeHtml(info.body) + '</p>'
            + '<button type="button" class="dating-save dating-state-btn" data-dating-radar-go="'
            + escapeHtml(info.go) + '">' + escapeHtml(info.action) + '</button>'
            + '</div>'
        );
    }

    // ── Canvas ───────────────────────────────────────────────

    _resize() {
        if (!this._canvas) {
            return;
        }
        const wrap = this._canvas.parentElement;
        if (!wrap) {
            return;
        }
        // Quadratisch, und nur so gross wie der Platz hergibt, der nach dem Text
        // uebrig bleibt.
        const side = Math.max(0, Math.floor(Math.min(wrap.clientWidth, wrap.clientHeight)));
        if (!side) {
            return;
        }
        const dpr = window.devicePixelRatio || 1;
        this._canvas.width        = Math.round(side * dpr);
        this._canvas.height       = Math.round(side * dpr);
        this._canvas.style.width  = side + 'px';
        this._canvas.style.height = side + 'px';
        this._ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        this._side = side;
    }

    _start() {
        if (this._running) {
            return;
        }
        this._running = true;
        const tick = (now) => {
            if (!this._running) {
                return;
            }
            // Sweep aus der Uhrzeit statt aus einem Zaehler: Bei ausgelassenen
            // Frames (Tab im Hintergrund) laeuft er weiter, statt zu ruckeln.
            const sweep = ((now % VCS.DatingRadar.SWEEP_MS) / VCS.DatingRadar.SWEEP_MS) * 2 * Math.PI;
            this._paint(sweep);
            this._raf = requestAnimationFrame(tick);
        };
        this._raf = requestAnimationFrame(tick);
    }

    _stop() {
        this._running = false;
        if (this._raf) {
            cancelAnimationFrame(this._raf);
            this._raf = 0;
        }
    }

    // ── Farben ───────────────────────────────────────────────

    // Aus den Design-Tokens statt fest verdrahtet. getAttribute pro Frame ist
    // billig, getComputedStyle waere es nicht — deshalb nur neu lesen, wenn das
    // Theme wirklich gewechselt hat.
    _colorSet() {
        const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        if (this._colors && this._colors.isDark === isDark) {
            return this._colors;
        }
        const cs  = getComputedStyle(document.documentElement);
        const get = (name, fallback) => this._parseRgb(cs.getPropertyValue(name)) || fallback;

        this._colors = {
            isDark      : isDark,
            accent      : get('--accent', [249, 115, 22]),
            accentLight : get('--accent-light', [251, 146, 60]),
            accentDark  : get('--accent-hover', [234, 88, 12]),
            accentDarker: get('--accent-darker', [194, 65, 12]),
            // Im hellen Theme braucht die Scheibe die kraeftigere Flaechenfarbe —
            // bg-elevated-2 laege dort fast auf dem Hintergrund und waere nicht
            // zu sehen.
            field       : get(isDark ? '--bg-elevated-2' : '--bg-elevated', isDark ? [47, 68, 88] : [255, 255, 255]),
            self        : get('--text-primary', isDark ? [255, 255, 255] : [26, 26, 26])
        };
        return this._colors;
    }

    _parseRgb(value) {
        const v = String(value || '').trim();
        let m = v.match(/^#([0-9a-f]{6})$/i);
        if (m) {
            const n = parseInt(m[1], 16);
            return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
        }
        m = v.match(/^#([0-9a-f]{3})$/i);
        if (m) {
            return [
                parseInt(m[1][0] + m[1][0], 16),
                parseInt(m[1][1] + m[1][1], 16),
                parseInt(m[1][2] + m[1][2], 16)
            ];
        }
        m = v.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
        if (m) {
            return [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
        }
        return null;
    }

    _rgba(rgb, alpha) {
        return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + alpha + ')';
    }

    // Pendant zu Color.lerp.
    _mix(a, b, t) {
        return [
            Math.round(a[0] + (b[0] - a[0]) * t),
            Math.round(a[1] + (b[1] - a[1]) * t),
            Math.round(a[2] + (b[2] - a[2]) * t)
        ];
    }

    // ── Blip-Position ────────────────────────────────────────

    // FNV-1a ueber den Handle. Streut den Punkt innerhalb SEINER Zelle: Zwei
    // Leute in derselben Zelle sollen nicht aufeinander liegen, und ein Punkt
    // exakt im Zellzentrum wuerde eine Genauigkeit behaupten, die niemand hat.
    // Derselbe Mensch landet dabei immer an derselben Stelle — ein springender
    // Blip saehe aus wie ein Zufallsgenerator.
    static hash(s) {
        let h = 0x811c9dc5;
        for (let i = 0; i < s.length; i++) {
            h = (h ^ s.charCodeAt(i)) >>> 0;
            // Math.imul: In JS ist * auf Doubles, ab 2^53 wuerde gerundet und der
            // Hash driftete von der App weg. imul rechnet echte 32-Bit-Multiplikation.
            h = (Math.imul(h, 0x01000193) >>> 0);
        }
        return h;
    }

    // Platz eines Kandidaten, gemessen aus den Zellen. null, wenn eine der
    // beiden fehlt (Fern-Modus, oder die Ortung war noch nicht dran) — dann
    // gehoert er nicht aufs Radar. Lieber kein Blip als ein erfundener.
    spotFor(c) {
        if (!this._myCell || !c || !c.cell) {
            return null;
        }
        const me    = VCS.DatingGeo.decode(this._myCell);
        const other = VCS.DatingGeo.decode(c.cell);

        // Streuung innerhalb SEINER Zelle — je groeber seine Wahl, desto weiter
        // streut es.
        const h = VCS.DatingRadar.hash(c.handle || '');
        const jitterLat = ((h % 1000) / 1000 - 0.5) * other.latHeight;
        const jitterLon = (((h >>> 10) % 1000) / 1000 - 0.5) * other.lonWidth;

        const mpd = VCS.DatingRadar.METERS_PER_DEGREE;
        const dyMeters = (other.lat + jitterLat - me.lat) * mpd;
        const dxMeters = (other.lon + jitterLon - me.lon) * mpd * Math.cos(me.lat * Math.PI / 180);

        // atan2(dx, dy) statt (dy, dx): Ergibt eine Peilung, 0 = Norden, im
        // Uhrzeigersinn — so wie man eine Karte liest. Minus PI/2 dreht sie in
        // die Canvas-Konvention (0 = rechts), in der Sweep und Painter rechnen.
        // Damit zeigt Norden auf dem Schirm nach oben, ohne dass der Rest davon
        // etwas wissen muss. Ohne die Drehung leuchten die Blips zur falschen
        // Zeit auf.
        const bearing = Math.atan2(dxMeters, dyMeters) - Math.PI / 2;
        const meters  = Math.sqrt(dxMeters * dxMeters + dyMeters * dyMeters);
        return {
            angle   : bearing,
            distance: Math.min(meters / VCS.DatingRadar.RANGE_METERS, 0.95)
        };
    }

    // ── Zeichnen ─────────────────────────────────────────────

    _paint(sweep) {
        const ctx = this._ctx;
        const s   = this._side;
        if (!ctx || !s) {
            return;
        }
        const cx = s / 2, cy = s / 2, radius = s / 2;
        const col = this._colorSet();

        ctx.clearRect(0, 0, s, s);
        this._paintField(ctx, cx, cy, radius, col);
        this._paintRings(ctx, cx, cy, radius, col);
        this._paintSweep(ctx, cx, cy, radius, col, sweep);
        this._paintBlips(ctx, cx, cy, radius, col, sweep);
        this._paintSelf(ctx, cx, cy, col);
    }

    // Die Scheibe. Zur Mitte hin ein Hauch Akzentfarbe — das gibt Tiefe, ohne
    // dass es nach Karte aussieht. Der Rand laeuft transparent aus, damit die
    // Scheibe nicht als Kreis auf dem Hintergrund klebt.
    _paintField(ctx, cx, cy, radius, col) {
        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);
        g.addColorStop(0.0, this._rgba(col.accent, col.isDark ? 0.07 : 0.12));
        g.addColorStop(0.62, this._rgba(col.field, col.isDark ? 0.22 : 0.85));
        g.addColorStop(1.0, this._rgba(col.field, 0));
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
        ctx.fill();
    }

    // Ringe ohne Beschriftung — Optik, keine Skala. Ein km-Wert stuende hier nur,
    // um falsch gelesen zu werden.
    _paintRings(ctx, cx, cy, radius, col) {
        ctx.strokeStyle = this._rgba(col.accent, col.isDark ? 0.13 : 0.28);
        ctx.lineWidth   = 1;
        for (const f of VCS.DatingRadar.RINGS) {
            ctx.beginPath();
            ctx.arc(cx, cy, radius * f, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }

    // Der Strahl: ein Keil, der nach hinten auslaeuft. Vorne eine schmale helle
    // Kante, damit man sieht, wohin er laeuft.
    _paintSweep(ctx, cx, cy, radius, col, sweep) {
        // createConicGradient beginnt bei sweep und laeuft eine volle Runde —
        // die hellste Stufe liegt damit genau am Strahl.
        const g = ctx.createConicGradient(sweep, cx, cy);
        g.addColorStop(0.0, this._rgba(col.accent, 0));
        g.addColorStop(0.55, this._rgba(col.accent, 0));
        g.addColorStop(0.80, this._rgba(col.accent, col.isDark ? 0.05 : 0.08));
        g.addColorStop(0.96, this._rgba(col.accent, col.isDark ? 0.20 : 0.30));
        // Im hellen Theme das satte Orange statt des hellen: accentLight
        // verschwindet auf Weiss, es wuerde nach nichts aussehen.
        g.addColorStop(1.0, this._rgba(col.isDark ? col.accentLight : col.accentDark,
            col.isDark ? 0.42 : 0.55));
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
        ctx.fill();

        // Die Kante des Strahls.
        const tx = cx + Math.cos(sweep) * radius;
        const ty = cy + Math.sin(sweep) * radius;
        const lg = ctx.createLinearGradient(cx, cy, tx, ty);
        lg.addColorStop(0, this._rgba(col.accent, 0));
        lg.addColorStop(1, this._rgba(col.isDark ? col.accentLight : col.accentDarker,
            col.isDark ? 0.75 : 0.85));
        ctx.strokeStyle = lg;
        ctx.lineWidth   = 1.6;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(tx, ty);
        ctx.stroke();
    }

    _paintBlips(ctx, cx, cy, radius, col, sweep) {
        for (const c of this._deck) {
            // Wer keine Zelle hat, hat keinen Platz.
            const spot = this.spotFor(c);
            if (!spot) {
                continue;
            }
            const x = cx + Math.cos(spot.angle) * spot.distance * radius;
            const y = cy + Math.sin(spot.angle) * spot.distance * radius;

            // Abstand des Strahls zum Blip, gegen die Drehrichtung gemessen:
            // 0 = gerade ueberstrichen, waechst bis zur naechsten Runde.
            let delta = (sweep - spot.angle) % (2 * Math.PI);
            if (delta < 0) {
                delta += 2 * Math.PI;
            }

            // Der Moment des Ueberstreichens: delta waechst eine Runde lang und
            // faellt genau dann von ~2*PI auf ~0 zurueck. Dieser Sprung ist das
            // Ereignis — einmal pro Blip und Runde, egal wie viele Frames
            // dazwischen liegen.
            const handle = c.handle || '';
            const prev   = this._lastDelta.get(handle);
            if (prev !== undefined && delta < prev - Math.PI) {
                this._beep(spot.distance);
            }
            this._lastDelta.set(handle, delta);

            // Grundhelligkeit bleibt: Der Mensch ist auch dann da, wenn der
            // Strahl gerade woanders steht. Ein Blip, der ganz verschwindet,
            // wirkt wie ein Fehler.
            const ag = VCS.DatingRadar.AFTERGLOW;
            const glow = delta > ag ? 0.22 : 0.22 + (1 - delta / ag) * 0.78;

            // Echo: Direkt nach dem Ueberstreichen laeuft ein Ring nach aussen.
            // Das ist der Moment, der aus einem Punkt ein Lebenszeichen macht.
            if (delta < 0.9) {
                const tt = delta / 0.9;
                ctx.strokeStyle = this._rgba(col.isDark ? col.accentLight : col.accentDark,
                    (1 - tt) * (col.isDark ? 0.5 : 0.65));
                ctx.lineWidth = 1.5;
                ctx.beginPath();
                ctx.arc(x, y, 6 + tt * 22, 0, 2 * Math.PI);
                ctx.stroke();
            }

            // Weicher Schein — nicht das harte Dreieck eines Flugzeugs. Hier sind
            // Menschen. Als Verlauf statt als Blur-Filter: billiger und auf
            // iOS-Safari zuverlaessiger.
            const glowRgba = this._rgba(col.accent, glow * (col.isDark ? 0.22 : 0.30));
            const gg = ctx.createRadialGradient(x, y, 0, x, y, 14);
            gg.addColorStop(0, glowRgba);
            gg.addColorStop(1, this._rgba(col.accent, 0));
            ctx.fillStyle = gg;
            ctx.beginPath();
            ctx.arc(x, y, 14, 0, 2 * Math.PI);
            ctx.fill();

            // Der Kern. Im Dunkeln leuchtet er zu Weiss hin auf; auf hellem Grund
            // waere das verschwinden statt leuchten — dort wird er stattdessen
            // satter und dunkler.
            const core = col.isDark
                ? this._mix(col.accentDark, [255, 255, 255], glow * 0.7)
                : this._mix(col.accentLight, col.accentDarker, glow);
            ctx.fillStyle = this._rgba(core, col.isDark ? 0.35 + glow * 0.65 : 0.55 + glow * 0.45);
            ctx.beginPath();
            ctx.arc(x, y, 5.5, 0, 2 * Math.PI);
            ctx.fill();
        }
    }

    // Du selbst, in der Mitte. Ehrlich: Es ist dein Radar, du bist der
    // Bezugspunkt — das ist die einzige Position auf dieser Scheibe, die
    // wirklich stimmt.
    _paintSelf(ctx, cx, cy, col) {
        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, 10);
        g.addColorStop(0, this._rgba(col.accent, col.isDark ? 0.18 : 0.28));
        g.addColorStop(1, this._rgba(col.accent, 0));
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(cx, cy, 10, 0, 2 * Math.PI);
        ctx.fill();

        // Textfarbe des Themes — im Dunkeln weiss, im Hellen fast schwarz. Der
        // Punkt bleibt so in beiden Faellen der ruhige Bezugspunkt.
        ctx.fillStyle = this._rgba(col.self, 1);
        ctx.beginPath();
        ctx.arc(cx, cy, 3.5, 0, 2 * Math.PI);
        ctx.fill();
    }

    // ── Tippen ───────────────────────────────────────────────

    _hitTest(px, py) {
        const radius = this._side / 2;
        const cx = radius, cy = radius;
        let hit  = null;
        let best = VCS.DatingRadar.TAP_RADIUS;

        for (const c of this._deck) {
            const spot = this.spotFor(c);
            if (!spot) {
                continue;
            }
            const x = cx + Math.cos(spot.angle) * spot.distance * radius;
            const y = cy + Math.sin(spot.angle) * spot.distance * radius;
            const d = Math.hypot(px - x, py - y);
            // Der naechstgelegene gewinnt — sonst faengt bei zwei dicht
            // beieinander liegenden Punkten immer der erste aus der Liste den
            // Tipp ab.
            if (d < best) {
                best = d;
                hit  = c;
            }
        }
        return hit;
    }

    // ── Events ───────────────────────────────────────────────

    _bindEvents() {
        const body = this._view.body;

        body.on('click', '#datingRadarCanvas', (e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const hit  = this._hitTest(e.clientX - rect.left, e.clientY - rect.top);
            if (hit) {
                // Diese Person kommt nach vorn, dann uebernimmt der Stapel. Die
                // anderen bleiben dahinter — wer im Radar war, verschwindet nicht,
                // nur weil man jemand anderen zuerst ansieht.
                VCS.datingDeck?.adoptFromRadar?.(this._deck, hit);
                VCS.dating?.showView?.('deck');
            }
        });

        body.on('click', '[data-dating-radar-browse]', () => {
            VCS.datingDeck?.adoptFromRadar?.(this._deck, null);
            VCS.dating?.showView?.('deck');
        });

        body.on('click', '[data-dating-radar-sound]', () => {
            this.toggleSound();
        });

        body.on('click', '[data-dating-radar-go]', (e) => {
            const go = String($(e.currentTarget).data('dating-radar-go'));
            if (go === 'profile') {
                VCS.dating?.showView?.('profile');
                return;
            }
            this._load();
        });
    }
};
